import React, { useContext } from 'react'
import { LegalFormalityDocumentContext } from 'contexts/LegalFormalityDocumentContext'
import TypesList from './TypesList'
import Details from './Details'
import Actions from './Actions'

const DocumentsTabView = () => {
  const { selectedDocumentListItem } = useContext(LegalFormalityDocumentContext)

  return (
    <>
      {selectedDocumentListItem && (
        <>
          <TypesList />
          <Details />
          <Actions />
        </>
      )}
    </>
  )
}

export default DocumentsTabView
